import { createAsyncThunk } from '@reduxjs/toolkit';
import { RECORD_TYPE } from 'LixaniAPI/enums';
import {
  selectProjectAndChildProjectEditableRecords,
  selectWorkCalendarFilteredRecords,
} from 'scenes/WorkDemo/store/selectors/workSelectorsDemo';

export const setAllFilteredRecordsToEdit = createAsyncThunk(
  'records/setAllFilteredRecordsToEdit',
  async (_, { getState }) => {
    const state = getState();
    const filteredRecords = selectWorkCalendarFilteredRecords(state);
    const editableRecords = selectProjectAndChildProjectEditableRecords(
      getState()
    );

    const selectableRecordTypes = [
      RECORD_TYPE.WORK,
      RECORD_TYPE.PROJECTWORK,
      RECORD_TYPE.ABSENCE,
    ];
    const records = filteredRecords.filter(
      (record) =>
        editableRecords.includes(record.id) &&
        selectableRecordTypes.includes(record.type)
    );

    return records;
  }
);
